export default __webpack_public_path__ + "static/media/defaultUser.5cd5073f.png";